import type { Timestamp } from 'spacetimedb';

export function formatBytes(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes <= 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.min(units.length - 1, Math.floor(Math.log(bytes) / Math.log(1024)));
  const v = bytes / 1024 ** i;
  return `${v >= 100 || i === 0 ? v.toFixed(0) : v.toFixed(1)} ${units[i]}`;
}

export function tsDate(ts: Timestamp | undefined | null): Date | null {
  if (!ts) return null;
  return new Date(Number(ts.microsSinceUnixEpoch / 1000n));
}

export function timeAgo(ts: Timestamp | Date | undefined | null): string {
  const d = ts instanceof Date ? ts : tsDate(ts as Timestamp);
  if (!d) return '';
  const s = Math.round((Date.now() - d.getTime()) / 1000);
  if (s < 45) return 'just now';
  if (s < 3600) return `${Math.round(s / 60)}m ago`;
  if (s < 86400) return `${Math.round(s / 3600)}h ago`;
  if (s < 30 * 86400) return `${Math.round(s / 86400)}d ago`;
  return d.toLocaleDateString();
}

export function formatDate(ts: Timestamp | undefined | null): string {
  const d = tsDate(ts);
  return d ? d.toLocaleString() : '';
}

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  return (parts[0][0] + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase();
}

/** Preview renders (for phone playback) are jobs too, but not exports. */
export function isPreviewJob(j: { kind: string; settings: string }): boolean {
  return j.kind === 'render' && j.settings.includes('"preview":true');
}

/** Media conversions (Convert… on assets): listed with the exports. */
export function isConvertJob(j: { kind: string }): boolean {
  return j.kind === 'convert';
}

/** Renders that are exports: not previews, and not still frames taken by AI assistants. */
export function isExportJob(j: { kind: string; settings: string }): boolean {
  return j.kind === 'render' && !isPreviewJob(j) && !j.settings.includes('"still":true');
}
